
import { defineComponent } from "vue";
import SelectPaymentMethod from "@/components/SelectPaymentMethod.vue";
import ViewHeader from "@/components/ViewHeader.vue";

export default defineComponent({
  components: {
    SelectPaymentMethod,
    ViewHeader,
  },
  setup() {
    return {};
  },
});
